module.exports = __webpack_public_path__ + "img/Img7_204465_JgEj-3-2128.1c8d3336.jpg";